"use strict";
// packages/contracts/src/apontamento-event.ts — Fase 02, Plano 06 (APT-01, D-10).
//
// Contrato de payload do evento atômico de apontamento (boa + refugo/NC + consumo).
// Validado pelo backend após o parse do envelope genérico de sync ou requisições REST diretas.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApontamentoPayloadError = void 0;
exports.parseApontamentoPayload = parseApontamentoPayload;
class ApontamentoPayloadError extends Error {
    reasonCode;
    constructor(reasonCode, message) {
        super(message);
        this.name = 'ApontamentoPayloadError';
        this.reasonCode = reasonCode;
    }
}
exports.ApontamentoPayloadError = ApontamentoPayloadError;
function isRecord(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
function requireNonEmptyString(obj, key) {
    const v = obj[key];
    if (typeof v !== 'string' || v.trim().length === 0) {
        throw new ApontamentoPayloadError('invalid-field', `campo ${key} obrigatório (string não vazia)`);
    }
    return v;
}
function requireNumber(obj, key, min = 0) {
    const v = obj[key];
    if (typeof v !== 'number' || Number.isNaN(v) || v < min) {
        throw new ApontamentoPayloadError('invalid-field', `campo ${key} deve ser numérico >= ${min}`);
    }
    return v;
}
function parseApontamentoPayload(input) {
    if (!isRecord(input)) {
        throw new ApontamentoPayloadError('invalid-payload', 'payload de apontamento deve ser objeto');
    }
    const osId = requireNonEmptyString(input, 'osId');
    const quantidadeBoa = requireNumber(input, 'quantidadeBoa', 0);
    const quantidadeNaoConforme = input.quantidadeNaoConforme !== undefined ? requireNumber(input, 'quantidadeNaoConforme', 0) : 0;
    const consumoReal = input.consumoReal !== undefined ? requireNumber(input, 'consumoReal', 0) : 0;
    const consumoPrevisto = input.consumoPrevisto !== undefined ? requireNumber(input, 'consumoPrevisto', 0) : 0;
    let motivoNc = null;
    if (quantidadeNaoConforme > 0) {
        motivoNc = requireNonEmptyString(input, 'motivoNc');
    }
    else if (typeof input.motivoNc === 'string' && input.motivoNc.trim().length > 0) {
        motivoNc = input.motivoNc.trim();
    }
    return {
        osId,
        quantidadeBoa,
        quantidadeNaoConforme,
        motivoNc,
        consumoPrevisto,
        consumoReal,
        insumoLoteId: typeof input.insumoLoteId === 'string' ? input.insumoLoteId : null,
    };
}
//# sourceMappingURL=apontamento-event.js.map